import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useSaleOrder from '../../hooks/useSaleOrder';
import notFoundImage from '../../../../../../../../../../public/assets/images/notFound.png';
import { statusClassMap } from 'models/SaleOrder';
import { Loader } from 'ncoded-component-library';

import './OrderDetails.styles.scss';

type OrderDetailsProps = { id?: string };
const OrderDetails = (props: OrderDetailsProps) => {
  const { id } = props;
  const { saleOrder, isLoading } = useSaleOrder(id);
  const { orderStatus, orderType, items, customerName, assignedAssociate } =
    saleOrder || {};

  const { t } = useTranslation();

  const className = classNames('hhsa-order-details');

  if (isLoading) return <Loader color="#007cb9" />;
  return (
    <div className={className}>
      <div className="hhsa-order-details__section">
        <span className="hhsa-order-details__section__title">
          {t('customerName')}
        </span>
        <span className="hhsa-order-details__section__info">
          {customerName}
        </span>
      </div>
      <div className="hhsa-order-details__section">
        <span className="hhsa-order-details__section__title">
          {t('orderStatus')}
        </span>
        <span
          className={classNames([
            'hhsa-sale-orders__status',
            `hhsa-sale-orders__status--${statusClassMap[orderStatus]}`,
          ])}
        >
          {orderStatus}
        </span>
      </div>
      <div className="hhsa-order-details__section">
        <span className="hhsa-order-details__section__title">
          {t('orderType')}
        </span>
        <span className="hhsa-order-details__section__type">{orderType}</span>
      </div>
      <div className="hhsa-order-details__section">
        <span className="hhsa-order-details__section__title">
          {t('assignedAssociate')}
        </span>
        <span>
          {assignedAssociate ? `${assignedAssociate.name}` : t('unnassgined')}
        </span>
      </div>
      <div className="hhsa-order-details__section">
        <span className="hhsa-order-details__section__title">{t('items')}</span>
        <div className="hhsa-order-details__section__items">
          {items?.map((item, index) => {
            const { storeProduct } = item || {};
            const { productCatalog } = storeProduct || {};
            return (
              <div
                key={index}
                className="hhsa-order-details__section__items__row"
              >
                <img
                  src={productCatalog?.imageUrls[0] || notFoundImage}
                  alt={item.skuNo}
                  className="hhsa-order-details__section__items__row__image"
                />
                <div className="hhsa-order-details__section__items__row__details">
                  <span className="hhsa-order-details__section__items__row__details__name">
                    {productCatalog?.name}
                  </span>
                  <span className="hhsa-order-details__section__items__row__details__sku">
                    {t('sku')}: {item.skuNo}
                  </span>
                  <span className="hhsa-order-details__section__items__row__details__count">
                    {t('count')}: {item.count}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default OrderDetails;
